import React, { Component } from 'react';
import {auth, firebase} from '../firebase';
import moment from 'moment'
import ModalConnection from './ModalConnectionSubscribe';
import {doSignOut} from '../authDB';


// id dev
//const idRestaurant="-LHCvfvi5Zis0rJffGlg"
// id prod
const idRestaurant="-L8HPl47r9qChaUm_6uU"

class App extends Component {
    constructor(){
        super()
        this.state={
           blog:{}

        }
    }
    show_connection(){
        this.refs.ModalConnection.handleShow();
    console.log(this.refs)
    }
    Deconx(){
      localStorage.removeItem('user')
      doSignOut().then(()=>{
        window.parent.location = window.parent.location.href;
    
      })
    }
componentDidMount(){
    var ref_blog= firebase.database().ref(`/blog/${idRestaurant}/${this.props.match.params.blog}`);

    ref_blog.on("value",(data)=>{
        console.log(data.val())
        if(data.val()!==null)
this.setState({blog:data.val()})
  
      })
}


  render() {
    return (
   <div>
         <header className="header">
            <div className="container">
                <div className="menubar">
                    <div className="row">
                        <div className="col-md-12">
                            <nav className="navbar navbar-static-top">
                             <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                    <a className="navbar-brand" href="/">
                                        <img src="/images/logo.png" className="img-responsive" alt="logo"/>
                                    </a>
                                </div>                      
     <div className="collapse navbar-collapse ">
                                    <ul className="nav navbar-nav navbar-right">
                                    
                                    <li className="res-btn">
                                          {(JSON.parse(localStorage.getItem('user')))?  <button onClick={()=>this.Deconx()} className="book-btn">Déconnection</button>:<button onClick={()=>this.show_connection()} className="book-btn">Connexion</button>}
                                    </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right" id="main-menu">

                                    <li className="">

                                         <a  href="/">
                                                Accueil
                                         </a>
                                    </li>
                                       {/*    <li className="">
                                            <a  href="/about">À propos</a>
    </li>*/}
                                        <li className="">
                                            <a  href="/order">Menu</a>                                          
                                        </li>
                                        {(JSON.parse(localStorage.getItem('user')))?  <li className="">
                                            <a  href="/historique">Historique</a>
                                        </li>:null       }     
                                        {(JSON.parse(localStorage.getItem('user')))?   <li className="">
                                            <a href="/loyalty">
                                            Fidélité
                                            </a>
                                        </li>  :null       } 
                                        <li className="active">
                                            <a   href="/Blog">
                                                Blog
                                            </a>
                                        </li>     
                                                          
                                        <li className="">
                                            <a   href="/contact">
                                                Contact
                                            </a>
                                        </li>  
                                                                           
                                    </ul>
                                </div>  
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mobile-menu" data-logo="/images/logo.png">


            </div>



        </header>
       

        <section className="page-title">
    <div className="container">
        <h2 className="title">
            Blog Detail
        </h2>
        <ul className="brdcrumb clearfix">
            <li>
                <a href="/">Home</a>
            </li>
           
            <li className="current">
                Blog Detail
            </li>
        </ul>
    </div>
</section>


<section className="blog-section blog-details-bg  blog-detail-page section-padding">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <div className="blog">
                    <div className="featured-pic">
                        <img src={this.state.blog.image?this.state.blog.image.url:"images/blog-detail.jpg"} alt="blog pic" className="img-responsive"/>
                    </div>

                    <div className="content">
                        <ul className="meta">
                            <li>
                                <i className="fa fa-calendar"></i> {moment(this.state.blog.created_at).format('LL')}
                            </li>
                          
                            <li>
                                <i className="fa fa-user"></i> Admin
                            </li>
                        </ul>
                        <h2 className="blog-title">
                        {this.state.blog.title}
                        </h2>
                        <p>
                        {this.state.blog.body}


                            </p>


                     
                        <hr/>
                        <ul className="pagi-simple clearfix">
                            <li>
                                <a href="#">
                                    <i className="fa fa-angle-left"></i> Prev
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    Next
                                    <i className="fa fa-angle-right"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                    
                </div>

              
            </div>
         
        </div>
    </div>
</section>
<section className="call-out-section section-padding">
    <div className="container">
        <div className="row">
            <div className="col-md-10">
                <h2>Découvrez le vrai goût de nos Plats.</h2>
            </div>
            <div className="col-md-2">
                <div className="call-out-btn">
                    <a href="/contact" className="btn-custom">Contactez nous</a>
                </div>
            </div>
        </div>
    </div>
</section>



       <ModalConnection ref="ModalConnection"/>

    </div>


       
   
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/blog-detail-page.js